module.exports = __webpack_public_path__ + "static/media/avatar.ac75689e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.svg
// module id = 32
// module chunks = 1